import { useEffect, useRef } from 'react'
import { useViewportScroll } from 'framer-motion'

import track from '~helpers/track'

export default function useScrollTracker() {
  const { scrollYProgress } = useViewportScroll()
  const trigger25 = useRef(false)
  const trigger50 = useRef(false)
  const trigger75 = useRef(false)
  const trigger100 = useRef(false)

  // Scroll listener to send Segment event based on where the user scrolls on the page
  useEffect(
    () =>
      scrollYProgress.onChange((v) => {
        if (v >= 0.25 && !trigger25.current) {
          trigger25.current = true

          track('Scrolled 25% of page')
        }

        if (v >= 0.5 && !trigger50.current) {
          trigger50.current = true

          track('Scrolled 50% of page')
        }

        if (v >= 0.75 && !trigger75.current) {
          trigger75.current = true

          track('Scrolled 75% of page')
        }

        if (v >= 1 && !trigger100.current) {
          trigger100.current = true

          track('Scrolled 100% of page')
        }
      }),
    [scrollYProgress]
  )
}
